import { MaintenanceWindowManuallyApprovedPatchesSelectorView } from '../view/MaintenanceWindowManuallyApprovedPatchesSelectorView';
import { templateMaintenanceWindowManuallyApprovedPatchesSelector } from '../view/template';
import { MaintenanceWindowManuallyApprovedPatchesSelectorRepository } from '../repository/MaintenanceWindowManuallyApprovedPatchesSelectorRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent } from '../index';
import { MaintenanceWindowManuallyApprovedPatchesSelectorWebComponentViewData } from '../types';
import { EnumListEvents } from '../../../ui/gzEnumList/types';

export class MaintenanceWindowManuallyApprovedPatchesSelectorController extends BaseWebComponentController {
  public component: MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent;
  public dataRepository: MaintenanceWindowManuallyApprovedPatchesSelectorRepository;
  public view: MaintenanceWindowManuallyApprovedPatchesSelectorView;
  public viewConstructor: typeof MaintenanceWindowManuallyApprovedPatchesSelectorView;
  public dataRepositoryConstructor: typeof MaintenanceWindowManuallyApprovedPatchesSelectorRepository;

  constructor(component: MaintenanceWindowManuallyApprovedPatchesSelectorWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: MaintenanceWindowManuallyApprovedPatchesSelectorView,
      viewTemplate: templateMaintenanceWindowManuallyApprovedPatchesSelector,
      dataRepositoryConstructor: MaintenanceWindowManuallyApprovedPatchesSelectorRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$patchesSelector,
        event: EnumListEvents.SELECTION_CHANGE,
        callback: this.updateSelectedPatchIds,
      },
    ];
  }

  async getDataForView(): Promise<MaintenanceWindowManuallyApprovedPatchesSelectorWebComponentViewData> {
    const companyId = this.dependencies.getActiveCompany().companyId;
    const availablePatches = await this.dataRepository.getManuallyApprovedPatchesForCompany(companyId);

    return {
      availablePatches,
      selectedPatchIds: this.component.selectedPatchIds,
    };
  }

  private updateSelectedPatchIds(): void {
    const selectedPatchIds = this.view.dom.$patchesSelector.filterOptions
      .filter(option => option.selected)
      .map(option => option.value.toString());

    this.component.setSelectedPatchIdsWithoutSideEffects(selectedPatchIds);
  }
}
